import type { Zeppelin, ZeppelinListResponse, ZeppelinQueryParams } from '../../models/ZeppelinModel';
import ZeppelinRepository from '../ZeppelinRepository';
import { apiFetch } from '../../utils/apiFetch';

export default class BeatAPIZeppelinRepository extends ZeppelinRepository {
  private _url: string;
  private _apiKey: string;

  constructor(url: string, apiKey: string) {
    super();
    this._url = url;
    this._apiKey = apiKey;
  }

  set url(url: string) {
    this._url = url;
  }

  set apiKey(apiKey: string) {
    this._apiKey = apiKey;
  }

  async getZeppelins(params: ZeppelinQueryParams): Promise<Zeppelin[]> {
    const query = new URLSearchParams();
    query.set('top_left[0]', String(params.top_left[0]));
    query.set('top_left[1]', String(params.top_left[1]));
    query.set('bottom_right[0]', String(params.bottom_right[0]));
    query.set('bottom_right[1]', String(params.bottom_right[1]));
    if (params.locale) {
      query.set('locale', params.locale);
    }
    if (params.tags && params.tags.length > 0) {
      params.tags.forEach((slug, i) => query.set(`tags[${i}]`, slug));
    }

    const response = await apiFetch(`${this._url}?${query.toString()}`, {
      method: 'GET',
      apiKey: this._apiKey,
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch zeppelins: ${response.status} ${response.statusText}`);
    }

    const data: ZeppelinListResponse = await response.json();
    return data.data;
  }
}
